import styled from 'styled-components';

export const StyledInputWrapper = styled.div`
    position: relative;
    padding-bottom: 18px;
    width: 330px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

    @media only screen and (max-width: 370px) {
        width: 100%;
    }
`;
